__turbopack_context__.v({
  "card": "HorairesPageView-module__1NpynG__card",
  "closed": "HorairesPageView-module__1NpynG__closed",
  "day": "HorairesPageView-module__1NpynG__day",
  "exceptions": "HorairesPageView-module__1NpynG__exceptions",
  "eyebrow": "HorairesPageView-module__1NpynG__eyebrow",
  "hero": "HorairesPageView-module__1NpynG__hero",
  "hours": "HorairesPageView-module__1NpynG__hours",
  "lead": "HorairesPageView-module__1NpynG__lead",
  "open": "HorairesPageView-module__1NpynG__open",
  "page": "HorairesPageView-module__1NpynG__page",
  "row": "HorairesPageView-module__1NpynG__row",
  "statusCard": "HorairesPageView-module__1NpynG__statusCard",
  "statusClosed": "HorairesPageView-module__1NpynG__statusClosed",
});
